import { Box, Button, Chip, Grid, Typography } from "@material-ui/core"
import React, { useCallback } from "react"
import { useStyles } from "./card-historico-pedido-styles"
import { toDateString } from "utils/to-date"
import { toDecimalString } from "utils/to-decimal"
import { StatusVendaMockTodos } from "api/mocks/status-situacao-mock"
import classNames from "classnames"
import { EnumTpStatusMov } from "models/enums/enum-tp-status-mov"
import { useThemeQueries } from "components/dialogs/dialog-adicionar-produto-com-subitem/util-styles"
import { ContinuarIcon } from "components/icons/continuar-icon"
import { VendaResumidoModel } from "models/api/venda/venda-resumido-model"

export type CardHistoricoPedidoProps = {
    pedido: VendaResumidoModel
    onClick: (id: string) => void
}

export const CardHistoricoPedido = ({ pedido, onClick }: CardHistoricoPedidoProps) => {
    const classes = useStyles()
    const { theme } = useThemeQueries()

    const retornarCorStatus = useCallback((): string => {
        switch (pedido.status) {
            case EnumTpStatusMov.Pendente:
                return theme.palette.warning.main;
            case EnumTpStatusMov.Finalizado:
                return theme.palette.success.main;
            case EnumTpStatusMov.Cancelado:
            case EnumTpStatusMov.Abortado:
            case EnumTpStatusMov.Rejeitado:
                return theme.palette.error.main;
            case EnumTpStatusMov.EmDigitacao:
                return theme.palette.warning.dark;
            default:
                return theme.palette.primary.main;
        }
    }, [pedido.status, theme.palette.warning.main, theme.palette.warning.dark, theme.palette.success.main, theme.palette.error.main, theme.palette.primary.main]);

    return (
        <Button
            className={classes.card}
            variant="outlined"
            color="default"
            fullWidth
            onClick={() => onClick(pedido.id)}
        >
            <Grid container>
                <Grid item xs container>
                    <Grid item xs={12}>
                        <Typography variant="h6" color="textPrimary" className={classes.textNota}>
                            N° Nota: {' '}
                            {pedido.nnf}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.endAlign}>
                        <Typography variant="body2" color="textSecondary" className={classes.feitoEm}>
                            Feito em: {toDateString(pedido.dhEmi, 'DD/MM/yyyy HH:mm')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box my={2} />
                    </Grid>
                    <Grid item xs={6}>
                        <Chip
                            className={classes.total}
                            style={{
                                backgroundColor: retornarCorStatus(),
                                color: theme.palette.getContrastText(retornarCorStatus()),
                                height: theme.spacing(3)
                            }}
                            label={StatusVendaMockTodos.find(x => x.Key === pedido.status)?.Value || 'Indefinido'}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="textPrimary" className={classNames(classes.total)}>
                            <Box component="span" className={classes.totalLabel}>Total:</Box> R$ {toDecimalString(pedido.totalVNf)}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs="auto">
                    <ContinuarIcon tipo="BUTTON" />
                </Grid>
            </Grid>
        </Button>
    )
}